import { useMutation, useQuery } from "react-query";
import {
  createRetur,
  getRetur,
  getReturDetail,
  HTTP_Request_Retur,
} from "./service";
import { AxiosError } from "axios";
import { useErrorHandler } from "../../../../../hooks/useErrorHandler";
import useSuccessHandler from "../../../../../hooks/useSuccessHandler";
import { Form_Create_Retur } from "../../../form/retur/FormRetur";

export const useCreateRetur = () => {
  const { showToastOnError } = useErrorHandler();
  const { showToast, redirect } = useSuccessHandler();

  return useMutation({
    mutationKey: ["retur"],
    mutationFn: ({
      description,
      invoice_id,
      payment_method_id,
      product_list,
      return_invoice_date,
    }: Form_Create_Retur) =>
      createRetur({
        description,
        invoice_id,
        payment_method_id,
        product_list,
        return_invoice_date,
      }),
    onSuccess: (e) => {
      showToast("Berhasil melakukan retur");
      redirect("/invoice");
    },
    onError: (e: AxiosError) => showToastOnError(e),
  });
};

export const useGetRetur = ({
  end_date,
  keyword,
  page,
  perPage,
  start_date,
}: HTTP_Request_Retur) => {
  return useQuery({
    queryKey: ["retur", end_date, start_date, keyword, page, perPage],
    queryFn: () => getRetur({ end_date, keyword, page, perPage, start_date }),
  });
};

export const useGetReturDetail = ({
  return_invoice_id,
}: {
  return_invoice_id?: string;
}) => {
  return useQuery({
    enabled: return_invoice_id !== undefined,
    queryKey: ["retur-detail", return_invoice_id],
    queryFn: () => getReturDetail({ return_invoice_id }),
  });
};
